import { Card } from '@material-ui/core'
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { getCountryFromUrl } from 'utils/CountryUtils'
import { devices } from 'utils/screen_sizes'
import { replaceWhiteSpaceWithHyphen } from 'utils/string_utils'

const StyledMobileWrapper = styled.div`
    @media ${devices.mobileS} {
        display: flex;
        flex-direction: column;
     
    }
    @media ${devices.mobileL} {
        display: flex;
        flex-direction: column;
       /* img{
        flex-basis:33.33%; 
       }
       div{
        flex-basis:100%;
        margin-left: 0px;
       } */
    }
    @media ${devices.laptop} {
        display: block
        margin-left: 0px;
    }
`

const StyledProductCard = styled(Card)`
    border-radius: 4px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    position: relative;
    padding: 1rem;
    margin-top: 5px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer

       @media ${devices.mobileM} {
            margin-top: 1.5rem
            font-size: 1rem;
        }
        @media ${devices.laptop} {
            margin-top: 1.2rem;
            margin-bottom: 35px;
        }


    .bestseller {
        margin-top: -16px;
        margin-left: -16px;
        width: fit-content;
    }
    img {
        object-fit: contain;
        /* width: fit-content; */
        max-height: 155px;
        margin: 1.5rem auto 0 auto;

        @media ${devices.mobileS} {
            width: 100%;
           margin: 1.3rem auto 0 auto;
               max-height: 150px;
        }
        @media ${devices.laptop} {
            width: 100%;
            margin: 1.5rem auto 0 auto;
               max-height: 155px;
        }
    }
    h4 {
        margin-top: 1.2rem;
        font-size: 1rem;
        margin-bottom: .5rem;
        
        @media ${devices.mobileS} {
            margin-top: 1.5rem
            font-size: 1rem;
        }
        @media ${devices.mobileM} {
            margin-top: 1.5rem
            font-size: 1rem;
        }
        @media ${devices.laptop} {
            margin-top: 1.2rem;
        }
    }
    p {
        margin: 0;
        font-size: 13px;
        @media ${devices.mobileS} {
            font-size: 0.9rem;
        }
        @media ${devices.mobileM} {
            font-size: 0.9rem;
        }
        :last-child {
            color: #777;
            /* margin-top: .5rem; */
            span {
                text-decoration: line-through;
                margin-right: 10px;
            }
            b {
                color: #000;
                font-weight: 600;
                margin-left: 5px;
                @media ${devices.mobileS} {
                    display: inline-block;
                    float: none;
                }
                @media ${devices.mobileM} {
                    display: inline-block;
                    float: none;
                }
            }
        }
    }
`

const ProductCard = ({
    imageUrl,
    title,
    initialPrice,
    discountedPrice,
    currency = 'KES.',
    _id,
    variantId,
}) => {
    const { pathname } = useLocation()
    let country = getCountryFromUrl(pathname) || 'ke'
    const history = useHistory()
    const handleBuyAction = () => {
        if (window.location.hostname === 'sell.badili.ke') {
            window.location = 'https://shop.badili.ke/'
        } else if (window.location.hostname === 'sell.badili.co.tz') {
            window.location = 'https://badili-tanzania.myshopify.com/'
        } else if (window.location.hostname === 'sell.badili.ug') {
            window.location = 'https://badili-uganda.myshopify.com/'
        } else {
            window.location = 'https://shop.badili.ke/'
        }
        // redirect to shopify store
    }
    return (
        <StyledProductCard
            style={{
                borderRadius: '12px',
                border: '1px solid rgba(0, 0, 0, 0.06)',
                background: '#FFF',
                //boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.08)",
                width: '212px',
                height: '316px',
                flexShrink: 0,
                boxShadow: '#FFF !important',
            }}
            available={true}
            onClick={handleBuyAction}
        >
            <StyledMobileWrapper>
                <div
                    className="bestseller"
                    style={{
                        color: '#FFF',
                        fontFamily: 'Open Sans',
                        fontSize: '12px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: '180%',
                        display: 'inline-flex',
                        padding: '4px 8px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        borderRadius: '12px 0px',
                        background: '#4B9757',
                        letterSpacing: '0.28px',
                    }}
                >
                    Upto 20% off
                </div>
                <img
                    src={imageUrl}
                    srcSet={`${imageUrl} 320w, ${imageUrl} 680w, ${imageUrl}   960w, ${imageUrl} 1980w`}
                    alt="phone"
                />
                <div>
                    <p
                        style={{
                            color: '#000',
                            fontFamily: 'Open Sans',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            lineHeight: '180%',
                            letterSpacing: '0.32px',
                        }}
                    >
                        {' '}
                        {title}
                    </p>

                    {/* <p>Warranty : 12months</p> */}
                    <p
                        style={{
                            color: 'rgba(0, 0, 0, 0.50)',
                            fontFamily: 'Open Sans',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            lineHeight: '180%',
                            letterSpacing: '0.28px',
                        }}
                    >
                        Starting from&nbsp;
                        {/* <span>{`${
                            currency +
                            ' ' +
                            discountedPrice.toLocaleString('en-US')
                        }`}</span> */}
                        <b
                            style={{
                                color: '#000',
                                fontFamily: 'Open Sans',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                lineHeight: '180%',
                                letterSpacing: '0.28px',
                            }}
                        >{`${
                            currency +
                            ' ' +
                            initialPrice.toLocaleString('en-US')
                        }`}</b>
                    </p>
                    <div
                        style={{
                            display: 'inline-flex',
                            padding: '4px 12px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '4px',
                            borderRadius: '8px',
                            background: '#ECF6FF',
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                        >
                            <path
                                d="M2 3.00191L7.71714 1.33334L13.4286 3.00191V6.42349C13.4285 8.17705 12.8767 9.88614 11.8513 11.3086C10.8259 12.7311 9.37887 13.7949 7.71524 14.3492C6.0511 13.7949 4.60358 12.731 3.57781 11.3082C2.55204 9.88545 2.00003 8.17592 2 6.42191V3.00191Z"
                                stroke="#468CCC"
                                stroke-width="1.3"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M4.85693 7.36504L7.07916 9.58726L10.8887 5.77774"
                                stroke="#468CCC"
                                stroke-width="1.3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <div className="text-wrapper">12 Months Warranty</div>
                    </div>
                </div>
            </StyledMobileWrapper>
        </StyledProductCard>
    )
}

export default ProductCard
